import { Injectable } from '@angular/core';
import { UsuarioLogado } from "../../model/usuario/usuario-logado";
import { UsuarioLogadoUtil } from "../../util/usuario-logado-util";
import { Menu } from '../../shared/menu-items/menu-items';

@Injectable({
  providedIn: 'root'
})
export class UsuarioMenuStorageService {

  private _KEY = 'COTACAO_USUARIO_MENU';

  constructor() {
  }

  public set(menu: Menu[]) {
    localStorage.setItem(this._KEY, JSON.stringify(menu));
  }

  public get(): UsuarioLogado {
    return Object.assign(UsuarioLogadoUtil.getInstance(), JSON.parse(localStorage.getItem(this._KEY)));
  }

  public remove() {
    localStorage.removeItem(this._KEY);
  }

}
